var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVideoGallery = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.776142 2 1 2.22386 1 2.5V15H13.5C13.7761 15 14 15.2239 14 15.5C14 15.7761 13.7761 16 13.5 16H0V2.5C0 2.22386 0.223858 2 0.5 2ZM15.125 0C15.65 0 16 0.35 16 0.875V13.125C16 13.65 15.65 14 15.125 14H2.875C2.35 14 2 13.65 2 13.125V0.875C2 0.35 2.35 0 2.875 0H15.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66944 4.33334H5.66389C5.29722 4.33334 5 4.63057 5 4.99723V9.00279C5 9.36945 5.29722 9.66668 5.66389 9.66668H9.66944C10.0361 9.66668 10.3333 9.36945 10.3333 9.00279V4.99723C10.3333 4.63057 10.0361 4.33334 9.66944 4.33334ZM12.3 4.85695L10.7778 5.90695V8.09307L12.3 9.14168C12.5944 9.34445 13 9.13751 13 8.78334V5.21529C13 4.86251 12.5958 4.65418 12.3 4.85695Z",
    fill: "#FADFED"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideoGallery, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/video-gallery.214c0b93.svg";
export { ForwardRef as ReactComponent };